import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { OrganizationListInitialState, OrganizationListLoad } from './organization-list.actions';
import { LIST_CLIENT_PAGINATION_INITIAL_STATE, ListClientPaginationStateModel } from '../../../../../common/models';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { OrganizationListService } from './organization-list.service';
import { OrganizationBrief } from '../models';
import { Error, CustomHttpErrorResponse } from '../../../../../common';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type OrganizationListStateModel = ListClientPaginationStateModel<OrganizationBrief>;

const initialState: OrganizationListStateModel = LIST_CLIENT_PAGINATION_INITIAL_STATE;

@State<OrganizationListStateModel>({
  name: 'organizationList',
  defaults: initialState,
})
@Injectable()
export class OrganizationListState {
  constructor(
    public organizationListService: OrganizationListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: OrganizationListStateModel): OrganizationListStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: OrganizationListStateModel): boolean {
    return state.loaded;
  }

  @Action(OrganizationListLoad)
  getOrganizations(
    ctx: StateContext<OrganizationListStateModel>,
    { payload }: OrganizationListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.organizationListService.getOrganizationList(payload).pipe(
      take(1),
      map((list: OrganizationBrief[]) => {
        ctx.patchState({ items: list, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(OrganizationListInitialState)
  setInitialState(ctx: StateContext<OrganizationListStateModel>): void {
    ctx.setState(initialState);
  }
}
